/**
 * @fileoverview Performance metrics tracking for page loads and image generation.
 *
 * This module provides utilities for measuring and tracking:
 * - Page load performance (Web Vitals: LCP, FCP, TTFB)
 * - Image generation request latency
 * - Custom performance measurements
 *
 * Metrics are logged to console in development and can be integrated
 * with analytics services in production.
 *
 * @module performance-metrics
 */

export * from "./performance-metrics/index";
